import { useEffect, useState } from "react";
import CookieFunctions from "../functions/CookieFunctions";
import File from "../components/File/File";
import { CCard, CCardBody, CCardTitle, CFormSelect, CButton } from "@coreui/react";

export default function Forms() {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileSelect = (e) => {
        const selectedIndex = e.target.selectedIndex;
        setSelectedFile(file[selectedIndex - 1]); // Adjust for the default disabled option
    };

    function getFroms() {
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());
        const formData = new FormData();

        formData.append("fileType", "Forms")

        fetch("/api/drivers/files",
            {
                headers: myHeaders,
                method: 'POST',
                body: formData,
            }
        ).then((res) => {
            if (res.ok) {
                return res.json()

            } else {
                throw new Error()
            }
        }).then((data) => {
            setFile(data);
            setLoading(false);
        })
    }

    useEffect(() => {
        setLoading(true);
        getFroms()

    }, [])

    function b64ToBlob(base64String) {
        const byteCharacters = atob(base64String);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: 'application/pdf' });
    }

    function downloadFile(fileData) {
        var b = b64ToBlob(fileData.fileBase64)
        const url = URL.createObjectURL(b);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileData.fileName;
        a.click();
        URL.revokeObjectURL(url);
    }

    return (
        <>
            {loading ? (
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <>
                    <h3>Select a File:</h3>
                    <CFormSelect onChange={handleFileSelect}>
                        <option disabled selected>No file selected</option>
                        {file ? (
                            file.map((f, i) => (
                                <option key={i} value={f.fileBase64}>
                                    {f.fileName}
                                </option>
                            ))
                        ) : (
                            <option disabled>No files to show</option>
                        )}
                    </CFormSelect>
                    {selectedFile && (
                        <CCard style={{ backgroundColor: "transparent", border: 'none' }}>

                            <CCardBody>
                                    <CButton color="primary" onClick={() => downloadFile(selectedFile)}>Download File</CButton>
                                <File file={`data:application/pdf;base64,${selectedFile.fileBase64}`} />
                                
                            </CCardBody>
                        </CCard>
                    )}
                </>
            )}
        </>
    );
}
